import { Box } from '@givebutter/primitives/box';
import { faComment } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ExpandableImage } from 'components/expandable-image';
import { useCurrentTransactionOrById } from 'customHooks/useCurrentTransactionOrById';

const TransactionDonationMessage = () => {
    const { data: transaction } = useCurrentTransactionOrById();

    return (
        <Box className={'flex flex-col gap-2 p-4'}>
            <div className={'flex items-center gap-2'}>
                <FontAwesomeIcon className={'text-brand-violet-primary'} icon={faComment} />
                <p className={'font-medium'}>Message from {transaction?.giving_space?.name}</p>
            </div>
            <p className={'italic'}>{transaction?.giving_space?.message}</p>
            {transaction?.giving_space?.visual && (
                <ExpandableImage src={transaction?.giving_space?.visual} />
            )}
        </Box>
    );
};

export { TransactionDonationMessage };
